import { API_AUTH } from "./common";

const QuanLyCuaHangApi = {
  combo: () => API_AUTH.get(`quan-ly-cua-hang/combo`, {}),
  chuyenCuaHang: ({ macuahang }) =>
    API_AUTH.get(`quan-ly-cua-hang/chuyen-cua-hang?macuahang=${macuahang}`, {}),
  thongTinCuaHangHienTai: () =>
    API_AUTH.get(`quan-ly-cua-hang/cua-hang-hien-tai`, {}),

  taoMaCuaHangMoi: () =>
    API_AUTH.get(`quan-ly-cua-hang/tao-ma-cua-hang-moi`, {}),

  themMoiCuaHang: (cuahang) =>
    API_AUTH.post(`quan-ly-cua-hang/them-moi-cua-hang`, cuahang),

  capNhatCuaHang: (cuahang) =>
    API_AUTH.post(`quan-ly-cua-hang/sua-cua-hang`, cuahang),

  chiTietCuaHang: (cuaHangId) =>
    API_AUTH.get(
      `quan-ly-cua-hang/chi-tiet-cua-hang?cuaHangId=${cuaHangId}`,
      {},
    ),
  kiemTraSoLuongCuaHangDuocTao: () =>
    API_AUTH.get(`quan-ly-cua-hang/kiem-tra-so-luong-cua-hang-duoc-tao`, {}),
};

export default QuanLyCuaHangApi;
